/**
 * Soul proposal inbox actions (Phase 2 soul evolution).
 */

import { fetchWithAuth } from './core';

export async function approveSoulProposal(threadId: string): Promise<{
  documentId?: string
  target_path?: string
}> {
  const res = await fetchWithAuth(`/api/threads/${threadId}/soul-proposal/approve`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  })
  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(apiErrorMessage(data, `Approve failed (${res.status})`))
  }
  return (await res.json()) as { documentId?: string; target_path?: string }
}

export async function dismissSoulProposal(threadId: string): Promise<void> {
  const res = await fetchWithAuth(`/api/threads/${threadId}/soul-proposal/dismiss`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: '{}',
  })
  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(apiErrorMessage(data, `Dismiss failed (${res.status})`))
  }
}

function apiErrorMessage(data: unknown, fallback: string): string {
  if (!data || typeof data !== 'object') return fallback
  const err = (data as { error?: unknown }).error
  if (typeof err === 'string' && err.trim()) return err
  if (err && typeof err === 'object') {
    const nested = (err as { message?: unknown }).message
    if (typeof nested === 'string' && nested.trim()) return nested
  }
  return fallback
}
